import React, { createContext, useContext } from 'react';
import type { LucideProps } from 'lucide-react';
import * as LucideIcons from 'lucide-react';

// Create context
interface IconContextType {
  getIcon: (name: string) => React.ComponentType<LucideProps> | null;
}

const IconContext = createContext<IconContextType | null>(null);

export const IconProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const getIcon = (name: string): React.ComponentType<LucideProps> | null => {
    // Convert to PascalCase for Lucide icons
    const pascalCase = name.charAt(0).toUpperCase() + name.slice(1);
    return (LucideIcons as any)[pascalCase] || null;
  };

  return (
    <IconContext.Provider value={{ getIcon }}>
      {children}
    </IconContext.Provider>
  );
};

// Hook to use the icon context
export const useIconContext = () => {
  const context = useContext(IconContext);
  if (!context) {
    throw new Error('useIconContext must be used within an IconProvider');
  }
  return context;
};